import { ApiCallWithErrorHandling, FilterValueDto } from "../../../Business/Common/CommonBusiness";
import { LogApi } from "../../../Business/LogOperation";
import { GET_FILTER_LOG, GET_FILTER_LOG_OPERATION, GET_LOG, GET_LOG_OPERATION, Log, LogGrid, LogQuery, LogQueryResultDto } from "../../../Model/Log";
import { rootStore } from "../../Store/rootStore";

export const GetLogOperation = async (query: LogQuery) => {
    let api = new LogApi();
    let data = await ApiCallWithErrorHandling(() => api.GetGrid(query));
    rootStore.dispatch({ type: GET_LOG_OPERATION, payload: { LogGridResult: data, filter: null } as LogGrid });
}



export async function GetFilterColumnLogOperation(columName: string, columValue: string, queryFilter?: LogQuery) {
    let result: FilterValueDto[] | undefined;
    let api = new LogApi();

    if (queryFilter !== null && queryFilter !== undefined) {
        result = await ApiCallWithErrorHandling<Promise<FilterValueDto[]>>(() => api.LogGetFilterResult(columName, columValue, queryFilter));
    } else {
        result = await ApiCallWithErrorHandling<Promise<FilterValueDto[]>>(() => api.LogGetFilterResult(columName, columValue));
    }
    let rtn = { filter: result, LogGridResult: null } as LogGrid;
    rootStore.dispatch({ type: GET_FILTER_LOG_OPERATION, payload: rtn });
}